<template>
    <div class="root">
      <div class="title">流量购买记录</div>
      <div class="order-list">

        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="loadData"
        >

        <div class="order-item"   v-for="item in list"
             :key="item.id">
          <div class="package-name" v-if="item.package">{{item.package.title}}</div>
          <div class="box">
              <div class="line1">
                <div class="left">{{item.packagetype.name}}</div>
                <div class="right">{{ item.price }}元</div>
              </div>
            <div class="line-2">账期开始：{{ item.startDate }} 00:00:00</div>
            <div class="line-2">账期结束：{{ item.endDate }} 59:59:59</div>
            <div class="line-2">订单号：{{ item.order_sn }}</div>
          </div>
          <div class="status success" v-if="item.refund_status==0">已支付</div>
          <div class="status refund" v-else>已退款</div>
        </div>


        </van-list>
      </div>
    </div>
</template>

<script>
    export default {
        name: "order",
        data() {
            return {
                loading: true,
                finished: false,
                error: false,
                list: []
            };
        },
        methods: {
            loadData() {
                this.error = false;
                this.fetchData('/order/index', {iccid: sessionStorage.getItem('iccid')}, (res) => {
                    this.loading = false;
                    if (res.code) {
                        this.list = res.data.data;
                        if (res.data.current_page >= res.data.last_page) {
                            this.finished = true;
                        }
                    } else {
                        this.error = true
                    }
                })
            }
        },
        created: function () {
            this.loadData();
        }
    };
</script>
<style lang="scss" scoped>
.root{
  height: inherit;
  font-size: 0;
  overflow-y: scroll;
  .order-list{
    padding-top: .4rem;
    width: 6.5rem;
    margin: 0 auto;
    .order-item{
      width: 5.5rem;
      padding: .2rem .3rem;
      background: #fff;
      border-radius: .26rem;
      margin: 0 auto .4rem;
      .package-name{
        text-align: left;
        color: #000;
        font-size: .32rem;
        line-height: .4rem;
      }
      .box{
        width: 4rem;
        padding: .2rem .2rem;
        margin: .2rem auto;
        border-top: 2px solid #d8d8d8;
        border-bottom: 2px solid #d8d8d8;
        .line1 {
          line-height: .32rem;
          margin-bottom: .2rem;
          display: flex;
          .left {
            flex: 1;
            font-size: .3rem;
            text-align: left;
          }

          .right {
            flex: 1;
            font-size: .3rem;
            text-align: right;
            color: #f05864;
          }
        }
        .line-2{
          font-size: .24rem;
          text-align: left;
          color: #555;
          line-height: 1.2;
        }
      }
      .status{
        font-size: .30rem;
        text-align: right;
      }
      .status.success{
        color: #f05864;
      }
      .status.refund{
        color: #83730d;
      }
    }
  }
  .title{
    font-size: .36rem;
    color: #fff;
    height: 1.2rem;
    line-height: 1.3rem;
    text-align: center;
    background: #f05864;
    letter-spacing: .12rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order.vue